import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../services';
import { Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';

@Pipe({
  name: 'tenantDescription',
})
export class TenantDescriptionPipe implements PipeTransform {
  constructor(private lookupSvc: LookupService) {}

  transform(tenantId?: number): Observable<string> {
    if (!tenantId) return of('');
    return this.lookupSvc.tenantDescription$(tenantId).pipe(filter((t) => !!t));
  }
}
